// @flow
import type { ThemeType, QuestionType } from 'types/Faq';

export function getThemeWithQuestion(themes: ThemeType[], questions: QuestionType[]){
  const array: ThemeType[] = themes.filter(theme => questions.filter(question => question.theme === theme.id).length > 0);
  return array;
}
